module.exports = __webpack_public_path__ + "img/8group-vrtree-icon.30abd09d.svg";